import { useToast } from "@chakra-ui/react";

export const useCustomTost = () => {
  const toast = useToast();

  return (
    title,
    description,
    status = "info",
    duration = 3000,
    position = "top-right"
  ) => {
    toast({
      title,
      description,
      status,
      duration,
      isClosable: true,
      position,
    });
  };
};
